module.exports = __webpack_public_path__ + "img/face-smile-halo.a2bb7539.svg";